import { useMedication } from '@hook'
import { NURSE_MODAL_TYPE, useModalStore } from '@modal'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  onClose: () => void
  id?: string
}

export const DeleteMed = ({ onClose, id }: Props) => {
  const { closeModal } = useModalStore()
  const [loading, setLoading] = useState(false)
  const { deleteMedication } = useMedication()
  const handleClose = () => {
    onClose()
    setLoading(false)
  }
  const handleSubmit = async () => {
    setLoading(true)
    try {
      await deleteMedication({ id: id || '' })
      showToast('Medication deleted successfully')
      handleClose()
      closeModal(NURSE_MODAL_TYPE.NURSE_DETAILS_MODAL)
    } catch (err: any) {
      setLoading(false)
      getError(err)
    }
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this medical history"
      handleSubmit={handleSubmit}
      isLoading={loading}
      onClose={handleClose}
      title="Delete Medical History"
    />
  )
}
